module.exports = __webpack_public_path__ + "assets/img/5dd4-it.svg";